// v2/layout/LayoutShell.tsx — Main layout composing Header, Sidebar/MobileNav, Breadcrumbs, content, EMI Calculator

import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useResponsive } from '../shared/hooks/useResponsive';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { MobileNav } from './MobileNav';
import { Breadcrumbs } from './Breadcrumbs';

export function LayoutShell(): React.ReactElement {
  const { isMobile } = useResponsive();
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className="flex h-screen flex-col">
      {/* Sticky header */}
      <Header onMenuToggle={isMobile ? () => setMobileNavOpen((o) => !o) : undefined} />

      <div className="flex flex-1 overflow-hidden">
        {/* Desktop sidebar */}
        {!isMobile && <Sidebar />}

        {/* Mobile slide-in drawer */}
        {isMobile && (
          <MobileNav open={mobileNavOpen} onOpenChange={setMobileNavOpen} />
        )}

        {/* Main content area */}
        <main className="flex-1 overflow-y-auto">
          <Breadcrumbs />
          <div className="p-4 md:p-6">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
